import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvprzx5m2y: FaireProductEntity = {
  token: "p_dvprzx5m2y",
  type: "product",
  name: "Natural Labradorite Crystal Lotus Carving Ornament",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Gemcohub",
  imageUrl:
    "https://cdn.faire.com/fastly/3bb311f6634a7f57327ba360ab980469f8ebf2947abda085eeb2fd307672cfa5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62ee1d21d6e13a020c136752be115d18a046a8a558b722aa8792186d65ef6d05.jpeg",
    "https://cdn.faire.com/fastly/febe7133eddeddfb36e56b6aeabe6ad23e0f306ca37d787dcd5fa34cb61fc7b7.jpeg",
    "https://cdn.faire.com/fastly/de421a039fdf1e3bb0b10132af6be9731c8077f63783ae9a7f4455ee59b1f11e.jpeg",
  ],
  priceDollars: 8.31,
  description:
    "'-ID: GEM-DHWH-OR2506\n-Material: Natural Blue Labradorite\n-Weight(s): 20g\n-Width: 1.4inch\n-Height: 1.0inch\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:20.660Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
